import React, { useEffect } from "react";
import PlanDetail from "../../../components/templates/Plans/PlanDetail/PlanDetail";
// import PlanDetailSEO from "../../../components/molecules/seo/Plans/PlanDetailSEO";
import TemplateSEO from "../../../components/molecules/seo/TemplateSEO";
import convertHTMLToPlainText from "../../../utils/convertHTMLToPlainText";
import { useRouter } from "next/router";
import Link from "next/link";

function PlanDetailPage(props) {
    const router = useRouter();

    // redirect to slug path
    useEffect(() => {
        console.log(router);
        if (router.query.plan_pk != props.plan.slug) {
            const prevQuery = router.query;
            prevQuery.plan_pk && delete prevQuery.plan_pk;

            router.replace({
                pathname: `/plans/plan/${props.plan.slug}`,
                query: { ...prevQuery },
            });
        }
    }, [router]);

    function getDescription(plan) {
        let description = convertHTMLToPlainText(plan.description).replace(
            /\n/g,
            " "
        );
        let title = `${plan.name} with ${plan.bedrooms} bedrooms, ${
            plan.bathrooms
        } bathrooms, a build cost of KSh ${plan.cost.toLocaleString()} , a minimum plot size of ${
            plan.minimum_plot_size
        }. (${plan.house_type})`;
        return `${description} - ${title}`;
    }

    return (
        <>
            {/* <PlanDetailSEO plan={props.plan} /> */}
            <TemplateSEO
                title={`${props.plan.name} | Inuua na Nachu`}
                description={getDescription(props.plan)}
            />
            {/*  <----------------------------------------- Breadcrumbs --------------------------------------------------> */}

            <div
                className="container-fluid bg-dark"
                // className="container-fluid bg-dark mt-2"
            >
                <div className="row">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 px-0">
                                <nav
                                    aria-label="breadcrumb"
                                    style={{
                                        borderRadius: "1px !important",
                                    }}
                                >
                                    <ol className="breadcrumb mb-0 bg-dark">
                                        <li className="breadcrumb-item">
                                            <Link href="/">
                                                <a className="text-info">
                                                    Home
                                                </a>
                                            </Link>
                                        </li>

                                        <li className="breadcrumb-item">
                                            <Link href="/nachu">
                                                <a className="text-info">
                                                    Inuua na Nachu
                                                </a>
                                            </Link>
                                        </li>

                                        <li className="breadcrumb-item">
                                            <Link href="/nachu/plans/">
                                                <a className="analytics-view-plans-link text-info">
                                                    Plans
                                                </a>
                                            </Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            {props.plan.name}
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <PlanDetail {...props.plan} hideBreadcrumbs />
        </>
    );
}

const cacheFile = "temp-plan-data-nachu.json";
export async function getStaticPaths() {
    let {
        fetchBuildingPlans,
        getPlanPaths,
    } = require("../../../utils/fetchBuildData");
    const plans = await fetchBuildingPlans(true, { tags: "NACHU" });

    return {
        paths: getPlanPaths(plans, cacheFile),
        fallback: false,
    };
}

export async function getStaticProps({ params }) {
    const { getPlan } = require("../../../utils/fetchBuildData");

    return {
        props: {
            plan: await getPlan(params.plan_pk, cacheFile),
        },
        // revalidate: 60 * 60 * 24 * 1, // 1 days
    };
}

export default PlanDetailPage;
